import { ChangeDetectionStrategy, Component, Input,  } from '@angular/core';
import { environment } from '@env';
import { NbDialogRef } from '@nebular/theme';
import { ApiService } from '@shared/services/api.service';

@Component({
  selector: 'app-new-version-available',
  templateUrl: './new-version-available.component.html',
  styleUrls: ['./new-version-available.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NewVersionAvailableComponent {
  @Input() features: Array<string> = [];

  constructor(
    protected dialogRef: NbDialogRef<NewVersionAvailableComponent>,
    private api: ApiService
  ) { }

  version() {
    return environment.appVersion;
  }

  close(): void {
    this.api.patchcConfirmNewVersion().subscribe();
    this.dialogRef.close();
  }
}
